import script from "./PortalLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalLinks.vue?vue&type=script&setup=true&lang=js"

import "./PortalLinks.vue?vue&type=style&index=0&id=4d0e7282&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d0e7282"]])

export default __exports__